"use strict";
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormattedGraphqlError = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _FormattedAxiosError = require("./FormattedAxiosError");
var _trimText = require("./trimText");
/**
 * This formats FormattedAxiosError into more readable object for logging only
 */ var FormattedGraphqlError = /*#__PURE__*/ function(_FormattedAxiosError_FormattedAxiosError) {
    _inherits(FormattedGraphqlError, _FormattedAxiosError_FormattedAxiosError);
    function FormattedGraphqlError(error) {
        _class_call_check(this, FormattedGraphqlError);
        var _this;
        _this = _call_super(this, FormattedGraphqlError, [
            error
        ]);
        (0, _defineProperty2.default)(_this, "graphqlVariables", void 0);
        (0, _defineProperty2.default)(_this, "graphqlQuery", null);
        _this.name = 'FormattedGraphqlError';
        _this.graphqlVariables = error.graphqlVariables;
        if (error.graphqlQuery != null) {
            if (process.env.NODE_ENV === 'production') {
                // Make sure that the query is trimmed so we won't overfill Application Insights
                _this.graphqlQuery = (0, _trimText.trimText)(error.graphqlQuery);
            } else {
                _this.graphqlQuery = error.graphqlQuery;
            }
        }
        return _this;
    }
    return FormattedGraphqlError;
}(_FormattedAxiosError.FormattedAxiosError);
exports.FormattedGraphqlError = FormattedGraphqlError; //# sourceMappingURL=FormattedGraphqlError.js.map
